/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataUserPageResVo } from './PageDataUserPageResVo';
import {
    PageDataUserPageResVoFromJSON,
    PageDataUserPageResVoFromJSONTyped,
    PageDataUserPageResVoToJSON,
    PageDataUserPageResVoToJSONTyped,
} from './PageDataUserPageResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataUserPageResVo
 */
export interface ResponsePageDataUserPageResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataUserPageResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataUserPageResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataUserPageResVo}
     * @memberof ResponsePageDataUserPageResVo
     */
    data?: PageDataUserPageResVo;
}

/**
 * Check if a given object implements the ResponsePageDataUserPageResVo interface.
 */
export function instanceOfResponsePageDataUserPageResVo(value: object): value is ResponsePageDataUserPageResVo {
    return true;
}

export function ResponsePageDataUserPageResVoFromJSON(json: any): ResponsePageDataUserPageResVo {
    return ResponsePageDataUserPageResVoFromJSONTyped(json, false);
}

export function ResponsePageDataUserPageResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataUserPageResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataUserPageResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataUserPageResVoToJSON(json: any): ResponsePageDataUserPageResVo {
    return ResponsePageDataUserPageResVoToJSONTyped(json, false);
}

export function ResponsePageDataUserPageResVoToJSONTyped(value?: ResponsePageDataUserPageResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataUserPageResVoToJSON(value['data']),
    };
}

